export default __webpack_public_path__ + "static/media/google_play_en.8a0e91e1.png";